import { PropsWithChildren } from 'react';

import { InlineCss } from '../types/common';
import * as S from './style';

export default function ErrorMessage({ children, inlineCss }: PropsWithChildren<InlineCss>) {
  return <S.ErrorMessage inlineCss={inlineCss}>{children}</S.ErrorMessage>;
}
